import React from 'react'

const TwitterFeed = () => (
    <React.Fragment>
        <iframe title="twitter-feed" style={{border:"none", width:"100%", position:"abslolute", top:"0",bottom:"0", height:"800px", borderSpacing:"border-box"}} src="../media/twitter.html" />
    </React.Fragment>
)

export default TwitterFeed